export default __webpack_public_path__ + "static/media/prohibido-el-paso.795817a7.png";